import React, { useState } from 'react';
import { JumbotronTypes } from '../../..';
// import { useWindowDimensions } from '../../../../../../../utilities/Dimensions';
// import { FontAwesomeIcon } from '../../../../../../../utilities/iconLoader/FontAwesomeIcon';
import { FormattedHrs } from '../../../../../../sitewide/components/locationMap/components/FormattedHrs';
import { convertCMSHrsToFormattedHrs } from '../../../../../../sitewide/components/locationMap/helpers/convertHrsToText';
import { useJumbotronContext } from '../../../context/jumbotronContext';

export const CardFormattedHrs = () => {
  // const { width } = useWindowDimensions();
  const [showFacilityHrs, setShowFacilityHrs] = useState(false);
  const onFacilityHrsToggle = () => {
    setShowFacilityHrs(!showFacilityHrs);
  };
  const jumbotronContext = useJumbotronContext();
  const { selectedLocation } = jumbotronContext;

  const getFormattedHrs = (hours: JumbotronTypes.TFacilityHours) => {
    return {
      officeHrs:
        hours.officeHrs && convertCMSHrsToFormattedHrs(hours.officeHrs),
      gateHrs: hours.gateHrs && convertCMSHrsToFormattedHrs(hours.gateHrs),
    };
  };
  const formattedHrs = selectedLocation?.facilityHours
    ? getFormattedHrs(selectedLocation.facilityHours)
    : '';
  return (
    <div className="CardFormattedHrs pt-2 is-flex">
      {formattedHrs && formattedHrs.officeHrs && (
        <div className="is-flex is-align-items-center">
          <div className="is-flex CardFormattedHrsHoursDiv is-flex-direction-column">
            {/* <div className='is-flex is-align-items-center'>
              <FontAwesomeIcon
                iconClassName="FaClock"
                iconContextProps={{
                  color: 'primary',
                  className: 'has-text-primary  HoursIcon mr-2',
                  style: {
                    fontSize: 32,
                  },
                }}
              />
              {selectedLocation.facilityHours.gateHrs &&
                selectedLocation.facilityHours.officeHrs &&
                width > 768 ? (
                <h5 className="officeHoursPara">Office Hours</h5>
              ) : (
                <h5 className="facilityHoursPara">Facility Hours</h5>
              )}
            </div> */}
            <FormattedHrs
              className="pt-0"
              onFacilityHrsToggle={onFacilityHrsToggle}
              formattedHrs={formattedHrs}
              show="facilityHrsOnly"
              color="primary"
              size={28}
            />
          </div>
        </div>
      )}
      {formattedHrs && formattedHrs.gateHrs && (
        <div className="is-flex is-flex-direction-row-reverse is-justify-content-flex-end is-align-items-center">
          <div className="is-flex CardFormattedHrsHoursDivGateAccess">
            {/* <div className='is-flex is-align-items-center'>
              <FontAwesomeIcon
                iconClassName="FaBuilding"
                iconContextProps={{
                  color: 'primary',
                  className: 'has-text-primary HoursIcon mr-2',
                  style: {
                    fontSize: 32,
                  },
                }}
              />
              <h5 className="gateHoursPara">Access Hours</h5>
            </div> */}
            <FormattedHrs
              className="pt-0"
              onFacilityHrsToggle={onFacilityHrsToggle}
              formattedHrs={formattedHrs}
              show="gateHrsOnly"
              color="primary"
              size={28}
            />
          </div>
        </div>
      )}
    </div>
  );
};
